import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const KakaoPayCancelPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/more/membership?result=fail', { replace: true });
  }, [navigate]);

  return null;
};

export default KakaoPayCancelPage;
